import React, { useMemo } from 'react';
import VenueCategoryApi from '../VenueCategoryApi';
import VenueCategorySettings from '../VenueCategorySettings';
import DropMenu from '@dex/bubl-dash/src/lib/components/DropMenu/DropMenu';
import Link from '@dex/bubl-dash/src/lib/components/Link/Link';

const VenueCategoryActions: React.FC<any> = (props: any) => {

    const { data } = props;

    const del = VenueCategoryApi.delete(data.id, {
        onComplete: (response) => {

            if (data.modelName && data.id) {
                const event = new CustomEvent(data.modelName + data.id, { detail: 'deleted' });
                window.dispatchEvent(event);
            }

        }
    });

    return useMemo(() => {

        return (

            <DropMenu>

                <Link
                    path={`${VenueCategorySettings.path}/${data.id}/view`}
                >
                    View
                </Link>

                <Link
                    path={`${VenueCategorySettings.path}/${data.id}/edit`}
                >
                    Edit
                </Link>

                <Link
                    confirm={{
                        title: `Delete ${data[VenueCategorySettings.primaryKey]}`,
                        message: "Are your sure you want to perform this action?"
                    }}
                    onClick={del.run}
                >
                    Delete
                </Link>

            </DropMenu>

        )

    }, [data, del]);

}

export default VenueCategoryActions;
